import { Box, LinearProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import CheckoutSectionContent from './Checkout.SectionContent';
import CheckoutSectionFooter from './Checkout.SectionFooter';
import CheckoutSectionHeader from './Checkout.SectionHeader';
import CheckoutSection from './Checkout.Section';

const DELAY_TO_SHOW_LOADING = 100;

export default () => {
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    if (!DELAY_TO_SHOW_LOADING) return;
    let timeout = setTimeout(() => setShowLoading(true), DELAY_TO_SHOW_LOADING);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="checkout checkout--loading">
      {showLoading && (
        <Box
          sx={{
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
          }}
        >
          <LinearProgress color="primary" />
        </Box>
      )}
      <div className="row">
        <div className="columns checkout__title">
          <h1>Kassa</h1>
        </div>
      </div>
      <div className="row">
        <div className="small-12 medium-9 columns">
          <CheckoutSection>
            <CheckoutSectionHeader />
            <CheckoutSectionContent />
            <CheckoutSectionFooter />
          </CheckoutSection>
        </div>
        <div className="small-12 medium-3 columns">
          <CheckoutSection>
            <CheckoutSectionHeader />
            <CheckoutSectionContent />
            <CheckoutSectionFooter />
          </CheckoutSection>
        </div>
      </div>
      <div className="row">
        <div className="small-12 medium-9 columns">
          <CheckoutSection>
            <CheckoutSectionHeader />
            <CheckoutSectionContent />
            <CheckoutSectionFooter />
          </CheckoutSection>
        </div>
      </div>
      <div className="row">
        <div className="small-12 medium-9 columns">
          <CheckoutSection>
            <CheckoutSectionHeader />
            <CheckoutSectionContent />
            <CheckoutSectionFooter />
          </CheckoutSection>
        </div>
      </div>
    </div>
  );
};
